import { ElDropdown } from 'element-plus/es';
import 'element-plus/es/components/dropdown/style/css';
import "core-js/modules/es.array.push.js";
import { computed, onMounted, onUpdated, reactive, ref, toRefs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const state = reactive({
      issearch: ref(false),
      value3: "2022"
    });
    const $router = useRouter();
    const $route = useRoute();
    const store = useStore();
    onMounted(() => {
      pathActive();
      methods.getSearch();
    });
    onUpdated(() => {
      pathActive();
    });
    // 头部 菜单的点击事件
    const bindheader = pathname => {
      if ($route.path == `/${pathname}`) return;
      $router.push(`/${pathname}`);
      store.commit("UpActive", pathname);
    };
    // 保持头部的 当前的激活
    const pathActive = () => {
      let pathactive = $route.path.split("/")[1];
      // console.log(pathactive);
      store.commit("UpActive", pathactive);
    };
    let methods = {
      getSearch() {
        var url = decodeURI(window.location.search);
        if (url.indexOf("?") != -1) {
          var str = url.substr(1); //得到?后面的字符串
          // var strs = str.split("&"); 
          let a = RegExp(/search=1/);
          state.issearch = a.test(str);
        }
      },
      goRealTime() {
        $router.push('/search');
        state.issearch = false;
      },
      // 选项下拉的点击事件
      ElDropdown(e) {
        let $index = e.target.dataset.index;
        if ($index == 1) {
          //进入搜索页
          $router.push('/search');
        } else {
          // 退出首页
          $router.push('/');
        }
      }
    };
    return {
      ...toRefs(state),
      bindheader,
      ...methods,
      hactive: computed(() => store.state.hactive)
    };
  }
};